import React, { useRef, useEffect } from "react";

const OtpInput = ({ otp, setOtp }) => {
  const inputsRef = useRef([]);

  useEffect(() => {
    // Focus the first input box when the component mounts
    if (inputsRef.current[0]) {
      inputsRef.current[0].focus();
    }
  }, []);

  const handleChange = (e, index) => {
    const { value } = e.target;
    if (/^[0-9]$/.test(value)) {
      // Only allow a single digit
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Move to the next input box
      if (index < 5) {
        inputsRef.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      // If backspace is pressed on an empty input, move to the previous one
      inputsRef.current[index - 1].focus();
    }
  };

  return (
    <div className="otp-input-container">
      {Array(6)
        .fill("")
        .map((_, index) => (
          <input
            key={index}
            ref={(el) => (inputsRef.current[index] = el)}
            type="text"
            maxLength="1"
            className="otp-box"
            value={otp[index] || ""}
            onChange={(e) => handleChange(e, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
          />
        ))}
    </div>
  );
};

export default OtpInput;
